/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

document.addEventListener('shopify:block:select', function(event){
  var sectionId = 'section-'+event.detail.sectionId;
  var blockId = event.detail.blockId;

  var section = document.getElementById(sectionId);
  if(section && section.classList.contains('socioh-collection-slider')) {
    document.getElementsByClassName('js-block-'+blockId).click();
  }
})

document.addEventListener('shopify:section:load',function(event){
  
  var sectionId = 'section-'+event.detail.sectionId;
  var section = document.getElementById(sectionId);

  if(section && section.classList.contains('socioh-countdown-timer'))
    sohCountdown.load(sectionId);

  if(section && section.classList.contains('socioh-sale-banner'))
    updateSociohSaleBannersVisibility();

 });


var sohCountdown = {
  timers: {},
  load: function(sectionId) {
    if(!sohCountdown.timers[sectionId]) {
      sohCountdown.timers[sectionId] = { sectionId: sectionId };
    }

    sohCountdown.initializeTimer(sectionId);
  },
  initializeTimer: function(sectionId) {
    var timer = sohCountdown.timers[sectionId];

    timer.rootElement = document.getElementById(timer.sectionId);
    timer.daysElement = timer.rootElement.getElementsByClassName('js-soh-countdown-days')[0];
    timer.hoursElement = timer.rootElement.getElementsByClassName('js-soh-countdown-hours')[0];
    timer.minutesElement = timer.rootElement.getElementsByClassName('js-soh-countdown-minutes')[0];
    timer.secondsElement = timer.rootElement.getElementsByClassName('js-soh-countdown-seconds')[0];
    timer.timerElement = timer.rootElement.getElementsByClassName('js-soh-countdown')[0];
    timer.daysPluralElement = timer.rootElement.getElementsByClassName('js-soh-countdown-days-plural')[0];
    timer.hoursPluralElement = timer.rootElement.getElementsByClassName('js-soh-countdown-hours-plural')[0];
    timer.minutesPluralElement = timer.rootElement.getElementsByClassName('js-soh-countdown-minutes-plural')[0];
    timer.secondsPluralElement = timer.rootElement.getElementsByClassName('js-soh-countdown-seconds-plural')[0];

    timer.settings = JSON.parse(timer.rootElement.getElementsByClassName('js-soh-countdown-settings')[0].innerHTML);
    timer.settings.timezone = '-04:00';
    
    if(timer.settings.after_completion == 'hide_section') {
      timer.hideSection = true;
      timer.hideTimer = false;
    } else if(timer.settings.after_completion == 'hide_timer') {
      timer.hideTimer = true;
      timer.hideSection = false;
    } else {
      timer.hideTimer = false;
      timer.hideSection = false;
    }

    timer.dateFuture = new Date(timer.settings.date+'T'+timer.settings.time+':00.000'+timer.settings.timezone);

    if(timer.interval)
      clearInterval(timer.interval);

    sohCountdown.updateTime(timer);
    timer.interval = setInterval(function(){
      sohCountdown.updateTime(timer);
    }, 1000);
  },
  updateTime: function(timer) {
    timer.dateNow = new Date();
  
    if(timer.dateFuture - timer.dateNow <= 0) {
      clearInterval(timer.interval);
      timer.daysElement.innerHTML = '0';
      timer.hoursElement.innerHTML = '0';
      timer.minutesElement.innerHTML = '0';
      timer.secondsElement.innerHTML = '0';

      if(timer.hideSection) {
        timer.rootElement.classList.add('soh-hide-section');
      }
      if(timer.hideTimer) {
        timer.timerElement.classList.add('soh-hide-timer');
      }
    } else {
      timer.seconds = Math.floor((timer.dateFuture - (timer.dateNow))/1000);
      timer.minutes = Math.floor(timer.seconds/60);
      timer.hours = Math.floor(timer.minutes/60);
      timer.days = Math.floor(timer.hours/24);

      timer.hours = timer.hours-(timer.days*24);
      timer.minutes = timer.minutes-(timer.days*24*60)-(timer.hours*60);
      timer.seconds = timer.seconds-(timer.days*24*60*60)-(timer.hours*60*60)-(timer.minutes*60);

      if(timer.days == 1) {
        timer.daysPluralElement.classList.add('hide-plural');
      } else {
        timer.daysPluralElement.classList.remove('hide-plural');
      }

      if(timer.hours == 1) {
        timer.hoursPluralElement.classList.add('hide-plural');
      } else {
        timer.hoursPluralElement.classList.remove('hide-plural');
      }

      if(timer.minutes == 1) {
        timer.minutesPluralElement.classList.add('hide-plural');
      } else {
        timer.minutesPluralElement.classList.remove('hide-plural');
      }

      if(timer.seconds == 1) {
        timer.secondsPluralElement.classList.add('hide-plural');
      } else {
        timer.secondsPluralElement.classList.remove('hide-plural');
      }

      timer.daysElement.innerHTML = timer.days;
      timer.hoursElement.innerHTML = timer.hours;
      timer.minutesElement.innerHTML = timer.minutes;
      timer.secondsElement.innerHTML = timer.seconds;
    }
  },
  initialize: function() {
    var timers = document.getElementsByClassName('socioh-countdown-timer');
    for(var i=0; i<timers.length; i++) {
      var sectionId = timers[i].id;
      sohCountdown.timers[sectionId] = { sectionId: sectionId };
      sohCountdown.initializeTimer(sectionId);
    }
  }
};

sohCountdown.initialize();

var updateSociohSaleBannersVisibility = function(banner) {

  var banners = document.getElementsByClassName('socioh-sale-banner');

  for(var i=0; i<banners.length; i++) {
    var banner = {};
    var toHide = false;

    banner.rootElement = banners[i];
    banner.settings = JSON.parse(banner.rootElement.getElementsByClassName('js-soh-sale-banner-settings')[0].innerHTML);
    banner.settings.timezone = '-04:00';
    
    if(banner.settings.start_date) {
      var dateString = banner.settings.start_date.split(' ').join('T');
      dateString += ':00.000'+banner.settings.timezone;

      var dateStart = new Date(dateString);
      var dateNow = new Date();

      if(dateNow < dateStart) {
        toHide = true;
      }
    }

    if(banner.settings.end_date) {
      var dateString = banner.settings.end_date.split(' ').join('T');
      dateString += ':00.000'+banner.settings.timezone;

      var dateEnd = new Date(dateString);
      var dateNow = new Date();

      if(dateNow > dateEnd) {
        toHide = true;
      }
    }

    if(toHide) {
      banner.rootElement.classList.add('hide-banner');
    } else {
      banner.rootElement.classList.remove('hide-banner');
    }
  }

  if(banners.length > 0) {
    setTimeout(updateSociohSaleBannersVisibility, 1000);
  }
}


var updateSociohAnnouncementBannersVisibility = function() {

  var banners = document.getElementsByClassName('AnnouncementBar');

  for (var i = 0; i < banners.length; i++) {
    var banner = {};
    var toShow = true; // Assume the banner should be shown

    banner.rootElement = banners[i];
    banner.settings = JSON.parse(document.getElementsByClassName('js-soh-announcement-banner-settings')[0].innerHTML);
    banner.settings.timezone = '-04:00';
    //banner.settings.timezone = '+05:30';

    var dateNow = new Date();

    if (banner.settings.start_announcement_date) {
      var dateString = banner.settings.start_announcement_date.split(' ').join('T');
      dateString += ':00.000' + banner.settings.timezone;
      var dateStart = new Date(dateString);

      if (dateNow < dateStart) {
        toShow = false; // Current time is before the start date
      }
    }

    if (banner.settings.end_announcement_date) {
      var dateString = banner.settings.end_announcement_date.split(' ').join('T');
      dateString += ':00.000' + banner.settings.timezone;
      var dateEnd = new Date(dateString);

      if (dateNow > dateEnd) {
        toShow = false; // Current time is after the end date
      }
    }

    if (toShow) {
      banner.rootElement.classList.add('show');
    } else {
      banner.rootElement.classList.remove('show');
    }
  }

  if (banners.length > 0) {
    setTimeout(updateSociohAnnouncementBannersVisibility, 1000);
  }
};

document.addEventListener('DOMContentLoaded', function() {
  const div = document.getElementById('section-announcement');
  if (div) {
    updateSociohAnnouncementBannersVisibility();
  }
});

var sohCollectionSlider = {
  sliders: {},
  initialize: function() {
    var sliders = document.getElementsByClassName('socioh-collection-slider');
    for(var i=0; i<sliders.length; i++) {
      var sectionId = sliders[i].id;
      sohCollectionSlider.sliders[sectionId] = { sectionId: sectionId };
      sohCollectionSlider.initializeSlider(sectionId);
    }
  },
  initializeSlider: function(sectionId) {
    var slider = sohCollectionSlider.sliders[sectionId];

    slider.rootElement = document.getElementById(slider.sectionId);
    slider.buttonLeft = slider.rootElement.getElementsByClassName('js-arrow-left')[0];
    slider.buttonRight = slider.rootElement.getElementsByClassName('js-arrow-right')[0];
    slider.contentContainer = slider.rootElement.getElementsByClassName('js-slider-content-container')[0];
    slider.tabs = slider.rootElement.getElementsByClassName('js-tab-single');
    slider.productSets = slider.rootElement.getElementsByClassName('js-slider-content');
    slider.selectedIndicator = slider.rootElement.getElementsByClassName('js-selected-indicator')[0];
    slider.contentLeft = 0;
    slider.selectedTab = 0;

    slider.selectedIndicator.style.width = slider.tabs[0].offsetWidth + 'px';

    for (let tab of slider.tabs) {
      tab.addEventListener('click', sohCollectionSlider.selectTab)
    }

    slider.buttonLeft.addEventListener('click', function(event) {
      sohCollectionSlider.slide(event, 1);
    });
    slider.buttonRight.addEventListener('click', function(event) {
      sohCollectionSlider.slide(event, -1);
    });

    sohCollectionSlider.updateArrowStatus(slider);

    slider.rootElement.addEventListener('touchstart', function(event) {
        sohCollectionSlider.touchstartX = event.touches[0].clientX;
        sohCollectionSlider.touchstartY = event.touches[0].clientY;
    }, false);

    slider.rootElement.addEventListener('touchend', function(event) {
        sohCollectionSlider.touchendX = event.changedTouches[0].clientX;
        sohCollectionSlider.touchendY = event.changedTouches[0].clientY;
        sohCollectionSlider.handleSwipe(event);
    }, false); 
  },
  handleSwipe: function(event) {
    if (sohCollectionSlider.touchendX < sohCollectionSlider.touchstartX) {
        sohCollectionSlider.slide(event, -1);
    }
    if (sohCollectionSlider.touchendX > sohCollectionSlider.touchstartX) {
        sohCollectionSlider.slide(event, 1);
    }
  },
  selectTab: function(event) {
    var sectionId = event.target.closest(".socioh-collection-slider").id;
    var slider = sohCollectionSlider.sliders[sectionId];
    var tab = event.target;
    var tabIndex = -1;

    for(var i=0; i<slider.tabs.length; i++) {
      if(slider.tabs[i] == tab) {
        tabIndex = i;
        break;
      }
    }
    
    // following line - safari automatically identifies the id field in the settings div as a phone number, applies special formatting and breaks
    // the json.parse in the following line
    // <meta name="format-detection" content="telephone=no"> - added this in <head> to avoid this
    var tabSettings = JSON.parse(slider.productSets[tabIndex].getElementsByClassName('js-soh-collection-slider-settings')[0].innerHTML);

    if(tabIndex != slider.selectedTab) {
      slider.selectedIndicator.style.left = tab.offsetLeft + 'px';
      slider.selectedIndicator.style.width = tab.offsetWidth + 'px';

      slider.productSets[slider.selectedTab].classList.add('hide-slider');

      setTimeout(function() {
        slider.productSets[slider.selectedTab].classList.remove('is-active');
        slider.productSets[slider.selectedTab].style.left = '0px';

        slider.contentContainer.style.height = tabSettings.height + 'px';

        slider.selectedTab = tabIndex;
        slider.productSets[slider.selectedTab].classList.add('is-active');
        slider.productSets[slider.selectedTab].classList.remove('hide-slider');

        sohCollectionSlider.updateArrowStatus(slider);
      }, 350);
    }
  },
  slide: function(event, direction) {
    var sectionId = event.target.closest(".socioh-collection-slider").id;
    var slider = sohCollectionSlider.sliders[sectionId];
    var activeProductSet = slider.rootElement.getElementsByClassName('is-active')[0];
    var slides = activeProductSet.getElementsByClassName('js-slide-single');
    var contentLeft = Math.abs(activeProductSet.offsetLeft);

    if(direction == 1) {
      for(var i=slides.length - 1; i>=0; i--) {
        if(slides[i].offsetLeft < contentLeft) {
          contentLeft = slides[i].offsetLeft;
          break;
        }
      }
    } else {
        for(var i=0; i<slides.length; i++) {
        if(slides[i].offsetLeft > contentLeft) {
          contentLeft = slides[i].offsetLeft;
          break;
        }
      }
    }
  
    activeProductSet.style.left = (-1 * contentLeft) + 'px';
    setTimeout(function(){
      sohCollectionSlider.updateArrowStatus(slider);
    }, 350);
  },
  updateArrowStatus: function(slider) {
    var activeProductSet = slider.rootElement.getElementsByClassName('is-active')[0];
    var contentLeft = Math.abs(activeProductSet.offsetLeft);

    if(contentLeft == 0) {
      slider.rootElement.getElementsByClassName('js-arrow-left')[0].classList.add('is-disabled');
    } else {
      slider.rootElement.getElementsByClassName('js-arrow-left')[0].classList.remove('is-disabled');
    }

    if(slider.contentContainer.offsetWidth + contentLeft >= activeProductSet.offsetWidth) {
      slider.rootElement.getElementsByClassName('js-arrow-right')[0].classList.add('is-disabled');
    } else {
      slider.rootElement.getElementsByClassName('js-arrow-right')[0].classList.remove('is-disabled');
    }
  }
}

sohCollectionSlider.initialize();